import Vue from "vue";

import TransactionLogAwards from "./TransactionLogAwards.vue";

export function load() {
    const selector = "transaction-log-awards";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(TransactionLogAwards, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
